function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M46 0.958008H0V29.2334H36.0806L40.3723 37.3758L44.664 29.2334H46V0.958008Z",
  fill: "#0F0F33"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 4.49219,
  y: 4.85742,
  width: 23.9527,
  height: 3.90716,
  rx: 1.95358,
  fill: "#FCF9F9"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 4.49219,
  y: 19.9277,
  width: 23.9527,
  height: 3.90716,
  rx: 1.95358,
  fill: "#FCF9F9"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.8,
  x: 19.4609,
  y: 12.3926,
  width: 23.9527,
  height: 3.90716,
  rx: 1.95358,
  fill: "#FA2C5A"
});

var SvgMessageBubble = function SvgMessageBubble(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 38,
    viewBox: "0 0 46 38",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMessageBubble, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Message_bubble.0d9d095f.svg";
export { ForwardRef as ReactComponent };